import { Link, useLocation } from "wouter";
import { ErpShell } from "../layout/ErpShell.js";
import { useT } from "../../i18n/index.js";

export function FiscalShell({
  subtitle,
  toolbar,
  children,
}: {
  subtitle: string;
  toolbar?: React.ReactNode;
  children: React.ReactNode;
}) {
  const [location] = useLocation();
  const t = useT();
  const NAV: ReadonlyArray<{ href: string; label: string }> = [
    { href: "/fiscal", label: t("fiscalShell.navKpis") },
    { href: "/fiscal/resultat", label: t("fiscalShell.navResultat") },
    { href: "/fiscal/sig", label: t("fiscalShell.navSig") },
    { href: "/fiscal/seuil", label: t("fiscalShell.navSeuil") },
    { href: "/fiscal/bilan", label: t("fiscalShell.navBilan") },
    { href: "/fiscal/budget", label: t("fiscalShell.navBudget") },
    { href: "/fiscal/entries", label: t("fiscalShell.navEntries") },
    { href: "/fiscal/tva", label: t("fiscalShell.navTva") },
  ];
  return (
    <ErpShell active="fiscal-sig">
      {/* Sub-navegação do módulo fiscal (tabs dentro da seção Fiscal) */}
      <div className="mb-5">
        <p className="text-xs uppercase tracking-wider text-neutral-500 mb-2">
          {t("fiscalShell.moduleLabel")} — {subtitle}
        </p>
        <nav className="flex flex-wrap gap-1">
          {NAV.map((n) => {
            const active =
              n.href === "/fiscal" ? location === "/fiscal" : location.startsWith(n.href);
            return (
              <Link
                key={n.href}
                href={n.href}
                className={
                  active
                    ? "rounded-md bg-lime/15 border border-lime/40 text-lime px-3 py-1 text-xs"
                    : "rounded-md border border-neutral-800 hover:border-lime hover:text-lime px-3 py-1 text-xs text-neutral-400"
                }
              >
                {n.label}
              </Link>
            );
          })}
        </nav>
      </div>
      {toolbar && <div className="border-b border-neutral-800 pb-3 mb-5 -mt-1">{toolbar}</div>}
      <div className="space-y-6">{children}</div>
    </ErpShell>
  );
}

export const fiscalInputClass =
  "rounded-md border border-neutral-800 bg-neutral-900 px-3 py-1.5 text-sm focus:border-lime outline-none disabled:opacity-50";

export function FiscalCard({
  title,
  subtitle,
  action,
  children,
  padded = true,
}: {
  title?: string;
  subtitle?: string;
  action?: React.ReactNode;
  children?: React.ReactNode;
  padded?: boolean;
}) {
  return (
    <section className="rounded-lg border border-neutral-800 bg-neutral-900 overflow-hidden">
      {(title || action) && (
        <div className="px-5 py-3 border-b border-neutral-800 flex items-center justify-between">
          <div>
            {title && (
              <h2 className="text-sm font-semibold uppercase tracking-wider text-neutral-300">
                {title}
              </h2>
            )}
            {subtitle && <p className="text-xs text-neutral-500 mt-0.5">{subtitle}</p>}
          </div>
          {action && <div>{action}</div>}
        </div>
      )}
      {children !== undefined && <div className={padded ? "p-5" : ""}>{children}</div>}
    </section>
  );
}

export function LoadingSkeleton({ rows = 3 }: { rows?: number }) {
  return (
    <div className="space-y-2">
      {Array.from({ length: rows }).map((_, i) => (
        <div
          key={i}
          className="h-4 rounded bg-neutral-800/60 animate-pulse"
          style={{ width: `${60 + ((i * 13) % 30)}%` }}
        />
      ))}
    </div>
  );
}
